import { useState } from 'react';
import type { ApprovalData } from '../types/approval';
import './ApprovalCard.css';

interface Props {
  approval: ApprovalData;
  onRespond: (requestId: string, decision: 'approved' | 'rejected') => Promise<boolean>;
}

export function ApprovalCard({ approval, onRespond }: Props) {
  const [loading, setLoading] = useState(false);

  const handleResponse = async (decision: 'approved' | 'rejected') => {
    setLoading(true);
    await onRespond(approval.requestId, decision);
    setLoading(false);
  };

  return (
    <div className={`approval-card ${approval.status}`}>
      <div className="approval-header">
        <span className="approval-icon">&#x1F510;</span>
        <span>需要你的确认</span>
      </div>
      <div className="approval-summary">{approval.summary}</div>
      <div className="approval-meta">
        <span className="approval-tag">{approval.tool}</span>
        {'command' in approval.params && (
          <span className="approval-tag">{String(approval.params.command).slice(0, 40)}</span>
        )}
      </div>

      {approval.status === 'pending' ? (
        <div className="approval-actions">
          <button
            className="approval-btn reject"
            onClick={() => handleResponse('rejected')}
            disabled={loading}
          >
            拒绝
          </button>
          <button
            className="approval-btn approve"
            onClick={() => handleResponse('approved')}
            disabled={loading}
          >
            允许
          </button>
        </div>
      ) : (
        <div className={`approval-result ${approval.status}`}>
          {approval.status === 'approved' ? '已允许' : '已拒绝'}
        </div>
      )}
    </div>
  );
}
